<template>
  <!-- <v-row justify="center"> -->
  <v-container class="contenedor_principal">
    <v-container class="continer_recuperar">
      <form style="margin-top: -30%;">
        <p
          class="txt_indicaciones"
        >Ingrese su número de teléfono, en el siguiente campo. <br>Le envíaremos un código.</p>
        <v-text-field
          label="TELÉFONO"
          prepend-inner-icon="mdi-cellphone"
          v-model="telefono"
          type="number"
          :error-messages="telefonoErrors"
          @input="$v.telefono.$touch()"
          @blur="$v.telefono.$touch()"
        ></v-text-field>
      </form>
    </v-container>

    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;" @click="submit('verificar')">ENVIAR CÓDIGO</v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required , numeric} from "vuelidate/lib/validators";
// import BarraNavegacion from '../components/BarraNavegacion/BarraNavegacion.vue'
import Vista from "@/objetos/vista";
import Verificar from "@/objetos/verificar";

// import Usuario from "@/objetos/usuario";

export default {
  mixins: [validationMixin],

  validations: {
    telefono: { required, numeric }
  },

  components: {},
  data: () => ({
    soloNumeros: [v => !isNaN(v) || "El valor debe ser numérico."],
    alert: true,
    telefono: null
  }),
  mounted() {
    Vista.nombre = "/recuperar";
    this.$root.$emit('finaliza_cronometro', true);
  },
  computed: {
    telefonoErrors() {
      const errors = [];
      if (!this.$v.telefono.$dirty) return errors;
      !this.$v.telefono.numeric &&
        errors.push("Debe ser un número válido.");
      !this.$v.telefono.required && errors.push("Teléfono es obligatorio");
      return errors;
    }
  },
  methods: {
    submit(nombre) {
      this.$v.$touch();
      Verificar.verificar_telefono = true;
      Verificar.mensaje_verificar_telefono = "Se ha enviado el código de verificación al teléfono ingresado, revise e ingrese el código en el siguiente campo."
      let ruta = `/${nombre.toLowerCase()}`
      if (this.pagina != nombre)
        this.$router.push(ruta)
    },
    clear() {
      this.$v.$reset();
    }
  }
};
</script>

<style scoped>
.contenedor_principal {
  display: table;
  height: 100%;
}
.continer_recuperar {
  border-radius: 10px;
  margin-top: 12%;
  width: 100%;
  display: table-cell;
  vertical-align: middle;
}
.txt_indicaciones {
    text-align: center; color:#515C6F; font-size:15px; 
}
</style>